import { render, staticRenderFns } from "./NewProduct.vue?vue&type=template&id=a16484cc&scoped=true&"
import script from "./NewProduct.vue?vue&type=script&lang=js&"
export * from "./NewProduct.vue?vue&type=script&lang=js&"
import style0 from "./NewProduct.vue?vue&type=style&index=0&id=a16484cc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a16484cc",
  null
  
)

export default component.exports